import { useQuery } from '@tanstack/react-query'
import {
	type HttpGetQueueCountsOptions,
	httpGetQueueCounts
} from '@/features/luxe-submissions/http/luxe-submissions.http'

export const QUEUE_COUNTS_QUERY_KEY = 'queue-counts'

export const useGetQueueCounts = (
	options: HttpGetQueueCountsOptions = { params: {} }
) =>
	useQuery({
		queryKey: [QUEUE_COUNTS_QUERY_KEY, options],
		queryFn: () => httpGetQueueCounts(options)
	})
